import React, { useEffect } from "react";
import Divider from "@material-ui/core/Divider";
import { Box, Popover, TextField } from "@material-ui/core";
import styles from "./EvrNumberForm.module.css";
import { Button } from "../../atomicComponents";
import clsx from "clsx";
import { useState } from "react";
import moment from "moment";
import { DATE_FORMAT } from "../../constants";
import { CustomSelect } from "../FormComponents";

const EvrNumberForm = ({ closeFormPopup, addEvrNumber, selectedRow, countryOptions, colorCodeOptions }) => {
  const [evrNumber, setEvrNumber] = useState("");
  const [quantity, setQuantity] = useState(0);
  const [plant, setPlant] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [countryName , setCountryName] = useState("")
  const [colourCode, setColourCode] = useState("");
  const [vc, setVc] = useState("");
  const [validFrom, setValidFrom] = useState(moment().format(DATE_FORMAT.ISO));
  const [validTo, setValidTo] = useState(moment().format(DATE_FORMAT.ISO));

  const extractColorCode = (fullColor) => {
    const match = fullColor.match(/\(([^)]+)\)/);
    return match ? match[1] : fullColor;
  };

  const handleSelectionCurry = (setState, isColorCode = false) => (valueObject) => {
    if (isColorCode) {
      // For color code, extract just the part in parentheses
      setState(extractColorCode(valueObject.value));
    } else {
      // For country code, just use the value
      setState(valueObject.value);
      if (valueObject.label.includes(" - ")) {
        setCountryName(valueObject.label.split(" - ")[1]);
      }
    }
  };
  useEffect(() => {
    if (selectedRow) {
      setEvrNumber(selectedRow[0].evrNumber || "");
      setQuantity(selectedRow[0].quantity || 0);
      setPlant(selectedRow[0].plant || "");
      setCountryCode(selectedRow[0].countryCode?.value || selectedRow[0].countryCode || "");
      setVc(selectedRow[0].vc || "");
      setValidFrom(selectedRow[0].validFrom || moment().format(DATE_FORMAT.ISO));
      setValidTo(selectedRow[0].validTo || moment().format(DATE_FORMAT.ISO));
      setColourCode(selectedRow[0].colourCode?.value || selectedRow[0].colourCode || "");
      setCountryName(selectedRow[0].countryName || "");
    }
  }, [selectedRow]);
  


  const formSubmit = (event) => {
    if (
      evrNumber &&
      quantity &&
      plant &&
      validFrom &&
      validTo &&
      countryCode &&
      countryName &&
      colourCode &&
      vc &&
      moment(validTo) >= moment(validFrom)
    ) {
      const formData = {
        evrNumber: evrNumber,
        quantity:quantity,
        plant: plant,
        validFrom: moment(validFrom).format("YYYY-MM-DD"),
        countryCode: countryCode,
        colourCode: colourCode,
        vc: vc,
        countryName: countryName,
      };
      addEvrNumber(formData);
      
    }
  };
  return (
    <>
      <Popover
        open={true}
        anchorOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        className={styles.popoverBck}
      >
        <form className={styles.formBox}>
          <div className={styles.formTitleNew}>
            <span className={styles.formTitle}>Evr Number Update</span>
            <div className={styles.formlLineDiv} />
          </div>
          <Box
            bgcolor="#dadada3d"
            paddingTop="14px"
            paddingBottom="14px"
            borderRadius="6px"
          >
            <span className={styles.titlespan}>Evr Number</span>
            <span
              style={{ display: "inline", marginLeft: "18%" }}
              className={styles.formSubTitle}
            >
              <TextField
              name="evrNumber"
              value={evrNumber}
              disabled
              className={clsx(styles.textField, styles.sel1)}
              InputProps={{
                disableUnderline: true,
                className: styles.select,
              }}
            />
            </span>
          </Box>
          <Divider className={styles.partitionLine} />
          <Box bgcolor="#dadada3d" paddingTop="17px">
            <span className={styles.titlespan}>Quantity  </span>
            <span
              style={{ display: "inline", marginLeft: "13%" }}
              className={styles.formSubTitle}
            >
              <TextField
              name="quantity"
              value={quantity}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[0-9]*$/.test(value)) {
                  setQuantity(value);
                }
              }}
              className={clsx(styles.textField, styles.sel1)}
              InputProps={{
                disableUnderline: true,
                className: styles.select,
              }}
            />
            </span>
          </Box>
          <Box bgcolor="#dadada3d" paddingTop="17px">
            <span className={styles.titlespan}>Plant</span>
            <span
              style={{ display: "inline", marginLeft: "20%" }}
              className={styles.formSubTitle}
            >
              <TextField
              name="plant"
              value={plant}
              disabled
              className={clsx(styles.textField, styles.sel1)}
              InputProps={{
                disableUnderline: true,
                className: styles.select,
              }}
            />
            </span>
          </Box>
          <Box bgcolor="#dadada3d" paddingTop="14px" paddingBottom="12px">
            <span className={styles.titlespan}>Country Code</span>
            <span
              style={{ display: "inline", marginLeft: "25px" }}
              className={styles.formSubTitle}
            >
              <CustomSelect
                name="countryCode"
                value={countryOptions.find(opt => opt.value === countryCode) || ""}
                onChange={handleSelectionCurry(setCountryCode)}
                options={countryOptions}
                className={styles.customSelect}
              />
            </span>
          </Box>
          <Box bgcolor="#dadada3d" paddingTop="5px" paddingBottom="18px">
            <span className={styles.titlespan}>Country Name</span>
            <span
              style={{ display: "inline", marginLeft: "18px" }}
              className={styles.formSubTitle}
            >
              <TextField
              name="countryName"
              value={countryName}
              disabled
              className={clsx(styles.textField, styles.sel1)}
              InputProps={{
                disableUnderline: true,
                className: styles.select,
              }}
            />
            </span>
          </Box>
          <Box bgcolor="#dadada3d" paddingTop="6x" paddingBottom="5px">
            <span className={styles.titlespan}>Colour Code</span>
            <span
              style={{ display: "inline", marginLeft: "35px" }}
              className={styles.formSubTitle}
            >
              <CustomSelect
            name="colourCode"
            value={colorCodeOptions.find(opt => extractColorCode(opt.value) === colourCode) || ""}
            onChange={handleSelectionCurry(setColourCode, true)}
            options={colorCodeOptions}
            className={styles.customSelect}
          />

            </span>
          </Box>
          <Box bgcolor="#dadada3d" paddingTop="14px">
            <span className={styles.titlespan}>Valid From</span>
            <span
              style={{ display: "inline", marginLeft: "45px" }}
              className={styles.formSubTitle}
            >
              <TextField
              name="Validfrom"
              value={validFrom}
              disabled
              className={clsx(styles.textField, styles.sel1)}
              InputProps={{
                disableUnderline: true,
                className: styles.select,
              }}
            />
            </span>
          </Box>
          <Box bgcolor="#dadada3d" paddingTop="14px" paddingBottom="20px">
            <span className={styles.titlespan}>Valid To</span>
            <span
              style={{ display: "inline", marginLeft: "65px" }}
              className={styles.formSubTitle}
            >
              <TextField
              name="validto"
              value={validTo}
              disabled
              className={clsx(styles.textField, styles.sel1)}
              InputProps={{
                disableUnderline: true,
                className: styles.select,
              }}
            />
            </span>
          </Box>
          <div style={{ float: "right" }}>
            <Button
              variant="primary"
              className={clsx(styles.button, styles.confirmButton)}
              type="button"
              onClick={formSubmit}
            >
              CONFIRM
            </Button>
            <Button
              className={clsx(styles.button, styles.cancelButton)}
              onClick={closeFormPopup}
            >
              CANCEL
            </Button>
          </div>
        </form>
      </Popover>
    </>
  );
};

export default EvrNumberForm;
